import { ThankYouSkeleton } from "@/components/checkout/thank-you/skeleton"

export default function ObrigadoLoading() {
  return <ThankYouSkeleton />
}
